export const _setRegion = (state, action) => {
  state.region = action.payload;
};
